// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"c2d18f96","1087":"cd023023","4371":"b4cd1af6","5255":"070dec3b","5350":"13a6e187","5947":"ced6d387","6012":"ced6d387","6176":"b626f313","8785":"ac195de6","8853":"38b0a8a3"}[chunkId] + ".chunk.css";
};